import { apiErrorMessage } from './ApiError';
import { ProductGroupModel } from '@app/interfaces/product/group';
import { axiosApi } from './axios.api';

const url = `/api/product/groups`;

export const getProductGroupsApi = async (): Promise<ProductGroupModel[] | undefined> => {
  try {
    const response = await axiosApi.get<ProductGroupModel[]>(url);
    return response.data;

  } catch (e: any) {
    throw new Error(e);
  }
};

export const createProductGroupApi = async (data: ProductGroupModel) => {
  try {
    const response = await axiosApi.post(url, data);
    return response.data;

  } catch (e: any) {
    throw new Error(e);
  }
};

export const updateProductGroupApi = async (productGroupId: number, formData: ProductGroupModel) => {
  try {
    const response = await axiosApi.put(`${url}/${productGroupId}`, formData);
    return response.data;

  } catch (e: any) {
    throw new Error(e);
  }
};

export const deleteProductGroupApi = async (productGroupId: number) => {
  try {
    const response = await axiosApi.delete(`${url}/${productGroupId}`);
    return response.data;

  } catch (e: any) {
    apiErrorMessage(e); // giữ lý do chặn xoá từ backend (422) thay vì 'Request failed...'
  }
};
